module.exports = __webpack_public_path__ + "img/accessory_shirt_05.f1f0f90f.svg";